import { Form, Input } from "antd";

import avatar from "assets/images/default.webp";
import { EducationHistory } from "./EducationHistory";
import {
  useGetTalentProfile,
} from "features/settings/hooks/useGetTalentProfile";
import { ChangeEvent, useState } from "react";
import { resizeImageToSquare, resizeCoverPhoto } from "utils/resizephoto";
import ProfileSidebar from "./TalentProfileSidebar";
import { FileWithPreview } from "features/settings/types";

const DEFAULT_COVER = "/assets/cover_image.png";

export const TalentEducation = () => {
  const { data, isLoading: isGetTPLoading } = useGetTalentProfile();
  const [form] = Form.useForm();
  const [file, setFile] = useState<FileWithPreview | null>(null);
  const [resizedBlob, setResizedBlob] = useState<Blob | null>(null);
  const [coverPhotoBlob, setCoverPhotoBlob] = useState<Blob | null>(null);
  const [active, setActive] = useState("Education");

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setFile({
        ...selectedFile,
        preview: URL.createObjectURL(selectedFile)
      } as FileWithPreview);
      try {
        const resizedImageBlob = await resizeImageToSquare(selectedFile, 200);
        setResizedBlob(resizedImageBlob);
      } catch (error) {
        console.error('Error resizing image:', error);
      }
    }
  };

  const coverPhotoChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setFile({
        ...selectedFile,
        preview: URL.createObjectURL(selectedFile)
      } as FileWithPreview);
      try {
        const resizedImageBlob = await resizeCoverPhoto(selectedFile);
        setCoverPhotoBlob(resizedImageBlob);
      } catch (error) {
        console.error('Error resizing image:', error);
      }
    }
  };


  return (
    <>
      <Form form={form} disabled={isGetTPLoading}>
        <div className="flex justify-between mb-4">
          <div>
            <h4 className="font-semibold text-lg text-primary">
              Personal info
            </h4>
            <h3 className="text-sm">Update your details here.</h3>
          </div>
        </div>
        <hr />
        <div className="grid grid-cols-1 md:grid-cols-5 my-3 md:my-5 gap-3">
          <Form.Item noStyle name="image">
            <Input type="hidden" />
          </Form.Item>

          <div className="relative col-span-5">
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              id="fileInput"
              onChange={coverPhotoChange}
            />
            <img
              src={
                coverPhotoBlob
                  ? URL.createObjectURL(coverPhotoBlob)
                  : data?.data.user.cover_photo || DEFAULT_COVER
              }
              alt="cover"
              className="w-full h-full object-cover"
            />

            <div className="absolute -bottom-6 left-4">
              <div className="relative w-fit">

                <img
                  src={
                    resizedBlob
                      ? URL.createObjectURL(resizedBlob)
                      : data?.data.dp ?? avatar
                  }
                  alt="avatar"
                  className="h-20 w-20 rounded-full border-2 border-white shadow-lg"
                />

                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="cover_photo"
                  onChange={handleFileChange}
                />
              </div>
            </div>

            <h3 className="font-medium mt-10"></h3>
            <h3 className="text-xs"></h3>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
          <ProfileSidebar active={active} onSelect={setActive} />

          <div className="md:col-span-5 p-4 rounded shadow-lg w-full">
            <EducationHistory isLoading={isGetTPLoading} data={data ? data?.data.education_histories : []} />
            <br />
            <hr />
        
          </div></div>
      </Form>
    </>
  );
};
